import { Bot, Cpu, Database, LineChart, type LucideIcon, Mail } from "lucide-react";

import type { ServizioCard, StatoServizio } from "@/hooks/useAgenteSalute";
import { cn } from "@/lib/utils";

const ICONA: Record<string, LucideIcon> = {
  email: Mail,
  agente: Bot,
  ai: LineChart,
  database: Database,
  risorse: Cpu,
};

const DOT: Record<StatoServizio, string> = {
  ok: "bg-emerald-500",
  warn: "bg-amber-500",
  err: "bg-red-500",
  sconosciuto: "bg-slate-300",
};

const SFONDO: Record<StatoServizio, string> = {
  ok: "",
  warn: "border-amber-200 bg-amber-50/50",
  err: "border-red-200 bg-red-50/50",
  sconosciuto: "",
};

export function HealthCard({ s }: { s: ServizioCard }) {
  const Icon = ICONA[s.id] ?? Bot;
  return (
    <div className={cn("flex items-start gap-3 rounded-lg border bg-card p-4", SFONDO[s.stato])}>
      <div className="grid size-9 shrink-0 place-items-center rounded-lg bg-muted">
        <Icon className="size-[18px] text-slate-600" />
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold">{s.titolo}</span>
          <span className={cn("size-2 rounded-full", DOT[s.stato])} />
        </div>
        <div className="text-xs text-muted-foreground">{s.sottotitolo}</div>
        <div className="mt-1.5 text-[11px] text-slate-400">{s.meta}</div>
      </div>
    </div>
  );
}
